import type { Logger } from 'pino';
import type { SyncHttpClient } from '@coderule/clients';

import type { SnapshotsRepo } from '../db/SnapshotsRepo';

export async function sendHeartbeat(
  rootId: string,
  snapshotsRepo: SnapshotsRepo,
  syncClient: SyncHttpClient,
  logger: Logger,
): Promise<void> {
  const latest = snapshotsRepo.getLatest();
  if (latest) {
    await syncClient.checkSnapshotStatus(latest.snapshot_hash);
  }
  logger.debug({ rootId }, 'Heartbeat sent');
}
